import { createContext, useContext, useState } from 'react';
import {
  addComposerItem,
  consumeComposerItems,
  restoreComposerItems,
  sameComposerItem,
  type ComposerItem,
} from './composer-draft.ts';

export function useComposerDraftState() {
  const [items, setItems] = useState<ComposerItem[]>([]);
  return {
    items,
    add: (item: ComposerItem) => {
      const snapshot = structuredClone(item);
      setItems((current) => addComposerItem(current, snapshot));
    },
    remove: (item: ComposerItem) =>
      setItems((current) => current.filter((candidate) => !sameComposerItem(candidate, item))),
    consume: (submitted: ComposerItem[]) =>
      setItems((current) => consumeComposerItems(current, submitted)),
    restore: (submitted: ComposerItem[]) =>
      setItems((current) => restoreComposerItems(current, submitted)),
  };
}

/** The stage owns this transient draft. Content-only renderers may have no composer. */
export const ComposerDraftContext = createContext<ReturnType<typeof useComposerDraftState> | null>(
  null,
);

export function useComposerDraft() {
  return useContext(ComposerDraftContext);
}
